import axios from "axios";
import envService from "@/services/env.service";
import userService from "@/services/user.service";
import { logger } from "@/services/logger.service";

const BASE_URL = envService.getApiBaseUrl() + '/sms/cost';

export default {
    getCostLimit(webId) {
        return axios.get(BASE_URL + '/' + webId + '/limit');
    },

    updateCostLimit(webId, costAlarmNational, costLimitNational,costAlarmInternational, costLimitInternational, costPeriode, costEmail) {
        return axios.put(BASE_URL + '/' + webId + '/limit',
            {
                "costAlarmNational": costAlarmNational,
                "costLimitNational": costLimitNational,
                "costAlarmInternational": costAlarmInternational,
                "costLimitInternational": costLimitInternational,
                "costPeriode": costPeriode,
                "costEmail": costEmail
            }, {
                headers: {
                    'X-User-Email': userService.getLoggedInUser().email,
                }
            })
    },

    // Neue Methode: gibt eine Liste aller CostLimits zurück
    async actualCostLimits() {
      try {
        return await axios.get(BASE_URL + '/limits', {
          headers: {
            'X-User-Email': userService.getLoggedInUser().email,
          }
        });
      } catch (error) {
        logger.error(error);
        throw error;
      }
    },
}
